import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useEffect, useRef, useState } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicCommentRembourser = () => {
  const { windowWidth, setOngletPaiementActif } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();

  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Paiements, tarification et remboursements", link: '/topics/paiement'},
    { label: 'Remboursements', link: '/topics/paiement/remboursements'},
    { label: topic.title, link: topic.link},
  ]

// <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/competitions`}>des compétitions</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Wodzone n’intervient pas dans la gestion des remboursements. Les modalités de remboursement sont précisées 
              dans les conditions générales de la compétition. 
            </p>
            <p className="help-text">
              Pour faire <a target='_blank' className="link" href={`/topics/inscription/39`}>une demande d'annulation et de remboursement,</a> 
              veuillez<a target='_blank' className="link" href={`/topics/rechercher/34`}>contacter</a>directement 
              les organisateurs.
            </p>
            <p className="help-text">
              Découvrez comment vous recevrez les remboursements auxquels vous avez droit, suivant les
              <a target='_blank' className="link" href={`/topics/inscription/40`}>conditions d'annulation</a>défini par
              les organisateurs.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Les remboursements sont versés sur le mode de paiement utilisé lors de la réservation. Dans de nombreux cas, 
                vous remarquerez à la fois des frais de paiement et un montant de remboursement distinct sur votre mode de paiement.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <p className="help-text">
                Si le compte associé à votre mode de paiement initial est fermé, le remboursement envoyé par Wodzone ne sera pas traité. Dans ce cas, 
                vous pouvez contacter votre banque ou votre établissement financier pour localiser les fonds. Si vous disposez toujours d'un compte chez eux, 
                ils pourront peut-être transférer le remboursement vers votre nouvelle carte ou votre nouveau compte. Dans certains cas, il est aussi possible 
                qu'ils vous envoient un chèque du montant du remboursement.
              </p>
              <p className="help-text">
                S'ils vous demandent des détails au sujet du remboursement, vous pouvez
                <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/contact`}>contacter Wodzone.</a> Nous pouvons vous fournir certaines informations, 
                notamment un numéro de référence qui peut s'avérer utile pour votre banque ou votre établissement financier.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part">{anchorsParts[2].content}</p>
              <p className="help-text">
                Les remboursements auxquels vous avez droit sont traités par les organisateurs dès que vous annulez une réservation, mais le délai de réception des 
                fonds dépend de votre banque ou de votre établissement financier. Consultez les
                <a target='_blank' className="link" href={`/topics/paiement/47`}>délais de remboursement habituellement constatés.</a>
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicCommentRembourser